import { render } from "./request-base-company.vue?vue&type=template&id=fe55c3ca&scoped=true&ts=true"
import script from "./request-base-company.vue?vue&type=script&lang=ts"
export * from "./request-base-company.vue?vue&type=script&lang=ts"

import "./request-base-company.vue?vue&type=style&index=0&id=fe55c3ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe55c3ca"]])

export default __exports__